// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__12o2K","activeLink":"Navigation_activeLink__2rUFB","NavList":"Navigation_NavList__i1TmR","NavItem":"Navigation_NavItem__2J7FH"};